var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polyline, _path8, _path9, _path10, _circle, _circle2, _circle3, _path11, _path12, _path13, _path14, _polyline2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle4, _circle5, _circle6, _circle7, _circle8, _g, _path31, _path32, _path33, _path34, _path35, _path36, _g2, _path37, _path38, _path39, _circle9, _circle10, _rect, _rect2, _polygon, _polygon2, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _circle11, _g3, _path52, _path53;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomepage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1440 880",
    style: {
      enableBackground: "new 0 0 1440 880"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FA7268;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#159497;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#AA6276;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#6E5DD8;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#AA6276;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M584.9,393.6c0.1-6.2,2.5-12.5,0.5-16.9c-1.3-2.8-4.5-3.9-7.2-5.2c-2-1-3.8-2.2-5.5-3.6c-1.2-1-2.5-2.1-4-2 c-1.5,0.2-2.6,1.7-2.7,3.1c-0.1,1.5,0.6,2.9,1.6,4.1s2.1,2.1,3.2,3.2c0.9,1,2.5,2.4,3.4,5.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M564.1,392.9c0.1-5.8-1.7-7.1-2.8-10.2s-2-6.5-1.2-9.7c0.5-2.2,2.2-4.5,4.5-4.6l1.7-0.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M571.8,367.6c3.3-2.5,8.2-2.6,11.7-0.4c0.8,0.5,1.5,1.1,2,1.9c1.2,1.9,0.9,3.8-0.2,7.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M563.4,377.7c2.5,2.2,6.3,2.7,9.3,1.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M648.8,426.8c1.1-5.3,4.7-10,9.5-12.4s10.7-2.6,15.6-0.4c4.7,2.1,8.3,6.1,12.9,8.5c13,6.6,29.3-1.6,43.2,2.7 c6.4,2,12,6.7,14.9,12.8c2.9,6.1,3.3,13.3,0.9,19.6c-1.8,4.7-4.9,8.7-8.5,12.1c-5,4.9-11,8.8-17.6,11.1 c-15.3,5.3-33.5,0.6-44.4-11.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303.9,659c-5.8-3.8-12-7-18.5-9.6c-1.8-0.7-4.3-1-5.1,0.7c-0.6,1.3,0.4,2.7,1.4,3.7c1.8,1.9,3.9,3.5,6,5 c-5.3,0.6-10.6,0.8-15.8,0.4c-1.7-0.1-3.3-0.3-5,0s-3.2,1.3-3.9,2.8c-0.6,1.5,0,3.6,1.6,4.1c-2.4,1.3-2.4,5.3,0,6.6 c-1.1,1-1.3,2.9-0.4,4.1c0.3,0.4,0.8,0.8,1.1,1.3c0.3,0.6,0.3,1.3,0.3,2c0.2,2.3,1.6,4.4,3.5,5.7c1.9,1.3,4.2,2,6.5,2.3 c9.1,1.3,17.9-2.8,26.3-6.4c0.6-0.3,1.7-0.4,1.8,0.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M689.3,653.1c-1-10.5-1.9-23.5-0.5-33.9c1.4-10.4,5.4-20.8,13.2-27.9c9.4-8.7,23.4-11.4,35.8-8.5 c12.4,2.9,23.4,10.8,31.4,20.7s13.5,21.7,17.7,33.8c6.8,19.6,10.4,40.3,10.7,61"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "653.5,704.4 653.5,652.9 696.2,652.9 696.2,687.7 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M680.3,694.2c-5-0.3-9.9-0.5-14.9-0.5c-1.9,0-4,0.1-5.6,1.2c-1.5,1.2-1.6,4.6,3.2,4.6 c-3.5,1.6-10.4,3.8-11.9,7.4s-0.7,9.1,2,11.9c2.2,2.3,5.5,3.2,8.6,3.5c6.5,0.5,14-2.4,19.1-6.4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M514.9,664.9c-0.4-0.2-0.7-0.3-1.1-0.5c-3.5-1.3-7.3-1.6-11-2.4c-3.1-0.7-6.3-1.8-8.6-4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.4,667.8c2.2,8.2,9.8,14,17.9,16.4c2.6,0.8,5.3,1.3,8,1.6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 645.9,
    cy: 458.4,
    r: 31.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 524.6,
    cy: 515,
    r: 31.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 524.6,
    cy: 461.4,
    r: 21
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M394.8,488.5c-15.8,0-28.8,11.5-31.2,26.6c-0.1,0-0.3,0-0.4,0c-2.8,0-5,2.3-5,5s2.3,5,5,5c0.1,0,0.3,0,0.4,0 c2.4,15.1,15.5,26.6,31.2,26.6c17.5,0,31.6-14.2,31.6-31.6C426.5,502.7,412.3,488.5,394.8,488.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.5,515.8c-0.1,0-0.3,0-0.4,0c-1.3-8.1-5.7-15.2-11.9-20.1c-1.5,4.2-5,8.4-7.8,10.5 c-4.6,3.6-10.4,5.3-14.9,9c-0.3,0.3-0.6,0.6-0.9,0.8c-1.1-0.9-2.6-1.5-4.2-1.5c-3.7,0-6.6,3-6.6,6.6c0,2.4,1.3,4.5,3.2,5.7 c-2.9,5.9-5,12.5-8.5,18.1c5.5,4.7,12.7,7.5,20.5,7.5c15.8,0,28.8-11.5,31.2-26.6c0.1,0,0.3,0,0.4,0c2.8,0,5-2.3,5-5 S241.3,515.8,238.5,515.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.1,605c7.9-0.8,15.3-3.6,21.1-9c11-10.1,14.6-27.6,27.7-34.7c3.3-1.8,7-2.8,10.4-4.4c4.2-2,8-5.1,10.9-8.8 c4.8-6.2,7.2-14.1,10.7-21.2c-1.9-1.2-3.2-3.3-3.2-5.7c0-3.7,3-6.6,6.6-6.6c1.6,0,3.1,0.6,4.2,1.5c0.3-0.3,0.6-0.6,0.9-0.8 c4.5-3.6,10.3-5.4,14.9-9c4.8-3.7,11.7-13.3,6.9-19.3c-4.6-5.7-15.8-4.7-22-3.5c-7.2,1.4-14.3,4-21.6,3.6c-6-0.4-11.9-2.8-17.9-2.7 c-10.3,0.1-19,7.4-25.8,15c-6.8,7.7-13,16.4-22,21.3c-5.4,2.9-11.5,4.3-17.3,6.5c-12.5,4.6-23.8,13.4-29.5,25.5 c-4.9,10.4-4.9,23.4,0.8,33.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M158.9,626.1l9-37.9c2-8.5,7-16,14-21.1l2.8-2c6.3-4.6,13.9-7.1,21.8-7.1h0c12.7,0,24.5,6.5,31.2,17.3l4.6,7.3 c2.7,4.4,4.5,9.3,5.2,14.4v0.8"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "247.9,627.8 247.9,697.6 177.3,697.6 "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.5,622.5c21.3,18.1,36.7,42.5,47.5,68.3s17.2,53.3,22.9,80.7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.3,767.1c-6.7-5.6-14.8-9.6-23.3-11.5c-10.4-2.4-21.6-1.9-31.6-5.6s-19.1-14.1-16-24.4 c2.1-6.9,9-11.3,15.7-13.9c7.6-3,15.7-4.8,23.9-5.2c-9.4-5.7-20.4-7.8-30.6-11.7c-10.3-3.8-20.6-10.2-24.4-20.4 c-1.5-4.1-1.7-9.2,1.3-12.4c1.6-1.7,3.9-2.6,6.2-3.3c5-1.5,10.2-2.4,15.4-2.5c-8.7-5.2-17.4-11.1-22.6-19.8 c-6.7-11.1-6.3-26.1,1-36.9c7.3-10.8,21-16.7,33.8-14.7c12,1.9,22.3,10.2,29.4,20.1c7,10,11.3,21.6,15.4,33.1 c2.6-8.9,12.5-14.5,21.7-13.7c9.2,0.8,17.4,7.1,22.3,15c4.8,7.9,6.6,17.4,7.1,26.6c0.7,15.1-2.1,30.3-8.1,44.1 c7.2-7.6,21-4.8,27.3,3.6c6.2,8.4,6.1,20,3.2,30.1c-2.9,10-8.3,19.1-12.2,28.9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M394.8,488.5c-5.8,0-11.3,1.6-16,4.4c1.3,7.9,3.9,15.5,7.4,22.7c1.4-1.9,3.6-3.1,6.1-3.1c4.2,0,7.6,3.4,7.6,7.6 c0,3.8-2.8,7-6.5,7.5c5.2,7.3,11.4,13.7,18.5,19.1c8.7-5.6,14.5-15.4,14.5-26.6C426.5,502.7,412.3,488.5,394.8,488.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M479.7,523.7c-7.3,0.1-13-6.7-15.5-13.6c-2.6-6.9-3.4-14.4-7.1-20.8c-4.7-8-14.3-13-23.4-11.7 c-9.2,1.3-17.1,9.3-17.8,18.5c1.3,1.4,2,2.5,3.4,3.9c4.4-3.7,11.5-1.9,15.4,2.3s5.4,10,6.6,15.6c1.3,5.6,2.6,11.4,6.3,15.8 c4.4,5.2,11.9,7.4,18.4,5.5C472.4,537.4,478.8,530.4,479.7,523.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.3,675.4c-3,7.7-6.6,15-10.9,22.2h119.1c-14.9-37-10-82.1-26.7-118.3c-2.4-5.3-5.4-10.5-9.8-14.5 c-7.5-6.8-18.6-8.9-28.3-6.1s-17.8,10.2-22.2,19.2c-2.9,6-4.3,12.6-5.5,19.2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.4,627.8c-0.4,2.5-0.8,4.9-1.2,7.3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.2,529.3c1.3-4.8,0-9.9-1.1-14.7c-1.1-4.9-1.8-10.2,0.5-14.6c1.8-3.4,5.1-5.8,7.9-8.4 c2.4-2.2,4.5-4.8,6.3-7.6c1.1-1.7,2.3-3.8,4.3-4.1c1.6-0.3,3.3,0.6,4.3,2s1.4,3,1.7,4.7c2.5,14-2.3,28.2-4,42.4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M332.6,529.3c-2.8-10.3,2.5-21.8-2.6-31.6c-1.9-3.7-5.2-6.3-7.8-9.5c-2.2-2.7-3.7-7.7-7.5-8.4 c-1.6-0.3-3.3,0.6-4.3,2c-1,1.3-1.4,3-1.7,4.7c-2.5,14,2.3,28.2,4,42.4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248.3,627.8c-6.1,0-12.2-0.9-18.4-2.7c-15.3-4.5-28.8-14.3-38-27.3c-5.8-8.2-2.2-19.6,7.2-22.9l0,0 c6.4-2.2,13.4,0.2,17.3,5.6c5.3,7.5,13.2,13.2,21.9,15.8c6.4,1.9,13,2,18.5,0.2c5.4-1.7,10-5.3,12.3-9.7c2.8-5.2,3.3-12.5,3.5-20.2 c0.4-12,0.4-25.3-0.1-37.3h30c0.5,12.7,0.5,25.6,0.1,38.4c-0.4,10.9-1.2,22.4-7.1,33.3c-6,11.3-16.9,20-29.7,24.1 C260.2,626.9,254.3,627.8,248.3,627.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.6,501.3c-0.6-3.4-0.6-6.9,0.1-10.3c0.2-1.2,0.7-2.6,1.9-3c1.4-0.5,2.8,0.7,3.6,1.9 c1.7,2.6,2.3,5.8,2.7,8.9c0.4,3.1,0.7,6.3,0.8,9.4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.4,483.5c4.5,2.5,9,5.1,13.5,7.6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M257.3,504.3c4.5,0,8.9-0.1,13.4-0.1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.9,522c2.9-1.7,5.7-3.4,8.6-5.1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M332.8,487.7c3.6-2.1,7.1-4.2,10.5-6.5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M336.7,501.1c4.2-0.4,8.4-0.9,12.7-1.3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M336.7,515c3.8,1.5,7.7,2.7,11.7,3.6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 229.2,
    cy: 517.2,
    r: 2.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 371.3,
    cy: 513.2,
    r: 2.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 517.1,
    cy: 524.2,
    r: 2.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 707.1,
    cy: 536.2,
    r: 2.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 533.2,
    cy: 524.2,
    r: 2.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 637.9,
    cy: 465.2,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 654,
    cy: 465.2,
    r: 2.2
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M225.6,529.3c0,3.9,3.2,7.1,7.1,7.1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M378.3,529.5c-2.8,2.7-7.3,2.6-10-0.2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M531.1,535.4c-2.8,2.7-7.3,2.6-10-0.2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M650.9,476.6c-2.8,2.7-7.3,2.6-10-0.2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M524.6,483.3c-12.7,0-23.6,7.4-28.6,18.2c17.1,12.6,38.9,18.8,60.1,17c0.1-1.2,0.2-2.4,0.2-3.6 C556.3,497.5,542.1,483.3,524.6,483.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M604.1,601.6c-10.7,0.7-20.4-6.4-27.5-14.4s-12.8-17.5-21.3-24c-11.5-8.9-27.1-11.4-41.3-8.5 c-20.1,4-39.6,17.9-49,36.3c-13.1,25.6-7.9,59.3,12.8,79.4c5.9-4.6,12.2-9.2,18.2-13.8c-4.1-9.1-7.5-18.8-7.2-28.7 c0.3-10,4.9-20.2,13.6-25.1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M611.9,681.2h-91.5c-5.3,0-8.5-4.3-7.2-9.6l15-60.2c1.3-5.3,6.7-9.6,12-9.6h91.5c5.3,0,8.5,4.3,7.2,9.6 l-15,60.2C622.5,676.9,617.2,681.2,611.9,681.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M611,697.6H509c-2.4,0-4.4-1.9-4.4-4.4v-3.7c0-2.4,1.9-4.4,4.4-4.4H611c2.4,0,4.4,1.9,4.4,4.4v3.7 C615.3,695.6,613.4,697.6,611,697.6z"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.5,798.7c12.7-31.1,42.4-54.7,75.6-60c33.2-5.3,68.8,7.7,90.6,33.3c35-36.1,87.1-54.9,137-49.4 c50,5.5,96.8,35.1,123.1,78c32.1-45.9,79.9-85.2,135.7-89.4c39.8-2.9,78.6,12.1,115.2,28.3c36.5,16.1,73.6,33.9,113.4,36.7 s84-13.1,101.9-48.8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.8,496.3c-20.6-77.1-15.2-160.9,15.1-234.8s85.4-137.3,154.3-177.7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.5,389.9c-14.3-23.2-26.8-47.5-37.4-72.6c-6.5-15.4-12.3-31.4-12.7-48.1c-0.3-16.7,5.7-34.3,19-44.3 c13.3-10,34.6-9.8,45.2,3c-6.7-35.7,3.5-74.2,26.9-101.9c7.5-8.9,16.6-16.9,27.6-20.5c11-3.7,24.2-2.3,32.7,5.6 c16-45,59.7-76.8,107.5-78.1c12.6-0.3,26.4,1.9,35.1,11c7.4,7.8,9.7,19.6,7.7,30.3c-2,10.6-7.7,20.2-14.6,28.6 c-23.1,28.1-57.9,43.4-91.4,57.8c9.8-2,19.8-4.1,29.7-2.3c9.8,1.8,19.5,8.4,21.8,18.1c3.2,13.5-8.1,25.8-19.1,34.3 c-26.8,20.7-57.5,36.3-90,45.8c7.8-0.7,15.7-1.3,23.3,0.5c7.6,1.8,14.9,6.4,18,13.6c2.9,6.8,1.4,14.9-2.2,21.4 c-3.6,6.5-9.2,11.7-14.8,16.6c-18.7,16.4-38.9,31.2-55.8,49.4s-30.6,40.7-32.8,65.4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 60,
    cy: 438.3,
    r: 9.9
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1346.9,
    cy: 315,
    r: 9.9
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 415.8,
    y: 124.7,
    className: "st1",
    width: 24.3,
    height: 24.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 788.2,
    y: 791,
    className: "st3",
    width: 19,
    height: 19
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1006.5,699.1 993,722.4 1019.9,722.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "99.6,70 109.6,52.7 89.6,52.7 "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1203.9,706.8c14.4,33.5,31.4,65.8,50.9,96.6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1252.2,690.4c28,36.7,60.7,69.9,96.9,98.6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1304.7,671.9c24.6,13.9,49.2,27.9,73.8,41.8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1274.8,434.6c19-26.4,52.3-41.8,84.6-39.1c11.6,1,24.8,5.7,28.2,16.8c2.7,8.7-1.7,17.9-6.4,25.7 c-15.7,25.9-36.5,48.7-61,66.6c14.9-12.4,36.2-16.5,54.7-10.6c7.2,2.3,14.6,6.8,16.6,14c1.9,6.9-1.6,14-5.2,20.1 c-11.8,19.7-26.8,37.5-44.2,52.5c5.6-1.8,11.4-3.7,17.3-3.6c5.9,0.1,12.1,2.5,15.3,7.5c5,8,0.5,18.5-5.1,26.1 c-15.1,20.7-38.1,35.5-63.2,40.7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M722.8,708.6c-12.5,7.2-26.9,11.4-41.9,11.8l-0.7-30c21.6-0.5,42-13.8,49.7-32.4c6.2-15.1,3-33.5-6.9-45.5 c-4.2-5.1-4.8-12.3-1.1-17.9l0,0c5.5-8.4,17.7-9.1,24.1-1.4c16.8,20.4,22.1,50.6,11.7,76.1C751,685.9,738.4,699.6,722.8,708.6z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M726.1,552.5c2.2-1.4,3.5-4,3.1-6.8c-0.4-2.7-2.6-5-5.3-5.6c-1.6-0.3-3.1-0.1-4.4,0.5c-2.9-7.2-4.3-15-4-22.7 c-0.1-0.1-0.1-0.1-0.2-0.1c-7,2.8-13,8.1-16.5,15.2c-0.1-0.1-0.2-0.1-0.4-0.2c-2.7-0.8-5.5,0.6-6.3,3.3c-0.8,2.7,0.6,5.5,3.3,6.3 c0.1,0,0.3,0.1,0.4,0.1c-0.7,4.5-0.3,9,0.9,13.1c2.3,0.2,4.7,0.5,7,0.7c2.4,0.3,3,3.5,0.8,4.6c-1.5,0.8-3.1,1.5-4.7,2.1 c3.8,6.5,10,11.7,17.8,14.2c10.9,3.4,22.3,0.6,30.3-6.4C739.2,566.9,731.7,560.4,726.1,552.5z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M777.1,543.3c-0.8-4.4-5-7.9-9.4-8c2.9-3.7,3-9.2,0.3-13c-2.7-3.8-8-5.4-12.4-3.9c1.7-5.8-1.5-12.7-7-15.2 c-5.5-2.5-12.8-0.3-16,4.9c-2.1-4.9-8.7-7.3-13.4-4.8c-4.1,2.1-5.9,8.2-4.5,12.8c0.6,1.9,0.8,3.9,0.9,5.8c0.2,6.4,1.6,12.7,4,18.7 c1.3-0.6,2.8-0.8,4.4-0.5c2.7,0.6,4.8,2.8,5.3,5.6c0.4,2.9-0.9,5.5-3.1,6.8c5.7,8.1,13.5,14.7,22.6,18.7c6,2.6,14.1,4.8,19.1,0.7 c5.1-4.2,6.5-12.1,3.3-17.8C775.2,552.5,777.9,547.7,777.1,543.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.4,627.8c-6,0-11.9-0.9-17.6-2.7c-12.9-4.1-23.7-12.8-29.7-24.1c-5.8-10.9-6.7-22.4-7.1-33.3 c-0.4-11.2-0.4-22.6-0.1-33.8c0.1-2.5,2.2-4.6,4.7-4.6h20.5c2.7,0,4.8,2.2,4.7,4.9c-0.3,10.7-0.3,22.1,0.1,32.5 c0.3,7.7,0.7,15,3.5,20.2c2.3,4.4,6.9,8,12.3,9.7L365,597L361.4,627.8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.2,685.4v-30c41.1,0,75-26.8,80.4-65.8c0.9-6.5,5.9-11.6,12.4-12.6l0,0c10-1.5,18.5,7.3,16.7,17.3 C404.1,646,358.6,685.4,304.2,685.4z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M645.9,426.8c-17.5,0-31.6,14.2-31.6,31.6c0,2,0.2,4,0.6,5.9c11.8-2,22.8-8.9,29.1-19.1 c6.4,11.8,19.6,19.4,32.9,19.7c0.4-2.1,0.7-4.3,0.7-6.6C677.6,440.9,663.4,426.8,645.9,426.8z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M576.6,587.2c13.3-14.1,3.9-47.8,13-64.7c2.6-4.8,2.1-10.7-1.1-15.1c-2.2-2.9-3.9-6.3-5.6-9.5 c-17.7-31.9-21.1-78.9-18.7-105l20.8,0.7c-0.2,17.9,11.3,63.7,19.5,79.6s24,28.8,41.9,29.2c12.9,0.3,25.7,4.3,35.8,12.3 c5.7,4.5,10.9,10.2,12.4,17.4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M496.9,170c10.5-8.9,21.5-17.9,34.4-22.8c12.9-4.9,28.3-5.2,39.8,2.4c9.5,6.3,15.8,17.5,26.7,20.8 c11.9,3.5,24.2-3.8,33.3-12.2c9.1-8.4,17.5-18.5,29.3-22.3c16.7-5.3,34.8,4,47.4,16.3c8.3,8.2,16.6,18.4,28.2,19.4 c10.6,0.9,20-6.4,30.1-9.7c12.7-4.1,27.3-1.6,37.9,6.5"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1244.1,
    cy: 143.4,
    r: 102.7
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M512.9,764.4h-63.4c-5.5,0-10-4.5-10-10v0c0-5.5,4.5-10,10-10h63.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M510.5,744.4c-5.8,5.8-6.1,14.7-0.8,20"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M508.3,744.4h-59.5c-3.1,0-5.7-2.5-5.7-5.7l0,0c0-3.1,2.5-5.7,5.7-5.7h59.5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M504.1,744.2c-3-3-3-8,0-11"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepage);
export default __webpack_public_path__ + "static/media/Homepage.bd1b28efd8c07042d32642d5c2b26704.svg";
export { ForwardRef as ReactComponent };